"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require("react-router");

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherOrderSuccessPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherOrderSuccessPanel, _Component);

  function VoucherOrderSuccessPanel() {
    (0, _classCallCheck3.default)(this, VoucherOrderSuccessPanel);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherOrderSuccessPanel.__proto__ || (0, _getPrototypeOf2.default)(VoucherOrderSuccessPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherOrderSuccessPanel, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetVoucherState();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Tilausvahvistus" }),
        _react2.default.createElement(
          "div",
          { className: "col-xs-8 col-xs-offset-2 voucher-order-success" },
          _react2.default.createElement("i", { className: "icon-mp-ok voucher-order-success-icon" }),
          _react2.default.createElement(
            "h1",
            { className: "h3", id: "gtm_new_voucher" },
            "Tilaus onnistui!"
          ),
          this.renderText()
        )
      );
    }
  }, {
    key: "getReturnLink",
    value: function getReturnLink() {
      switch (this.props.vouchers.orderType) {
        case _VoucherUtil.RECEPTION_ORDER_TYPE:
          return "/ostetut-vastaanottolipukkeet";
        case _VoucherUtil.PICKUP_ORDER_TYPE:
          return "/ostetut-noutolipukkeet";
        default:
          break;
      }
    }
  }, {
    key: "renderText",
    value: function renderText() {
      if (this.props.user) {
        return _react2.default.createElement(
          "p",
          null,
          "Voi nyt siirty\xE4 selaamaan ja tulostamaan ",
          _react2.default.createElement(
            _reactRouter.Link,
            { to: this.getReturnLink() },
            "lipukkeita."
          )
        );
      }

      return _react2.default.createElement(
        "p",
        null,
        "L\xF6yd\xE4t tilauksessa k\xE4ytt\xE4m\xE4st\xE4si s\xE4hk\xF6postista linkin lipukkeiden selaamiseen ja tulostamiseen."
      );
    }
  }]);
  return VoucherOrderSuccessPanel;
}(_react.Component), _class.propTypes = {
  resetVoucherState: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  vouchers: _react.PropTypes.object.isRequired
}, _temp);
exports.default = VoucherOrderSuccessPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/VoucherOrderSuccessPanel.js
 ** module id = 489
 ** module chunks = 0
 **/